import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { Loader } from 'src/domains/layouts/webview/components/loader/Loader';
import { withConfig } from 'src/withConfig';

interface MeetingsPropsType {
    variant: DefaultComponentVariantType | null;
}

const setMeetingsInfo = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            border-radius: ${theme.star.radius.medium};
        `;
    }
    return css`
        border-color: ${theme.star.meetingsAntePost.borderColor};
        border-style: solid;
        border-width: 0 1px;
    `;
};

export const MeetingsInfo = withConfig(theme => styled('div', { label: 'MeetingsInfo' })<MeetingsPropsType>`
    ${({ variant }): SerializedStyles => setMeetingsInfo(variant, theme)}
    background: ${theme.star.meetingsAntePost.bgColorSecondary};
    color: ${theme.star.meetingsAntePost.txtColor};
    flex: 1 1 0%;
    font-size: ${theme.star.fontSize.xRegular};
    padding: 10px 5px;
    position: relative;
    text-align: center;
`);

export const LoaderWrapper = styled(Loader, { label: 'LoaderWrapper' })`
    justify-content: center;
`;

const setMeetingsGroupWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            padding: 0 ${theme.star.padding.medium} ${theme.star.padding.medium};
            display: flex;
            flex-flow: column nowrap;
            gap: ${theme.star.gap.medium};
            background: ${theme.star.meetingsAntePost.bgColorTertiary};
            @media ${theme.star.mediaQuery.tablet} {
                border-radius: 0 0 ${theme.star.radius.medium} ${theme.star.radius.medium};
            }
        `;
    }
    return css``;
};


export const MeetingsGroupWrapper = withConfig(theme => styled('div', { label: 'MeetingsGroupWrapper' })<MeetingsPropsType>`
    ${({ variant }): SerializedStyles=> setMeetingsGroupWrapper(variant, theme)};
`);

const setMeetingsInfoWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            padding: 0 ${theme.star.padding.medium} ${theme.star.padding.medium};
            background: ${theme.star.meetingsAntePost.bgColorTertiary};
        `;
    }
    return css``;
};

export const MeetingsInfoWrapper = withConfig(theme => styled('div', { label: 'MeetingsInfoWrapper' })<MeetingsPropsType>`
    ${({ variant }): SerializedStyles=> setMeetingsInfoWrapper(variant, theme)};
`);
